import Layout from "@/layout";

export default {
  path: "/assets",
  component: Layout,
  meta: { title: "Assets", icon: "assets-v2" },
  name: "Assets",
  children: [
    {
      path: "trucks",
      name: "Trucks",
      component: () => import("@/views/assets-v3"),
      meta: { title: "Trucks", system: 'dispatch' },
    },
    {
      path: "trailers",
      name: 'Trailers',
      component: () => import("@/views/assets-v3"),
      meta: { title: "Trailers", system: 'dispatch' },
    },
    {
      path: 'truck/details',
      name: 'TruckDetails',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trucks", system: 'dispatch' },
      hidden: true,
    },
    {
      path: 'trailer/details',
      name: 'TrailerDetails',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trailers", system: 'dispatch' },
      hidden: true,
    },
    {
      path: 'create/truck',
      name: 'CreateTruck',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trucks", system: 'dispatch' },
      hidden: true,
    },
    {
      path: 'create/trailer',
      name: 'CreateTrailer',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trailer", system: 'dispatch' },
      hidden: true,
    },
    {
      path: 'edit/truck/:fleetId/:assetsId',
      name: 'EditTruck',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trucks", system: 'dispatch' },
      hidden: true,
    },
    {
      path: 'edit/trailer/:fleetId/:assetsId',
      name: 'EditTrailer',
      component: () => import("@/views/assets-v3"),
      meta: { activeMenu: "/assets/trailer", system: 'dispatch' },
      hidden: true,
    },
  ],
};
